import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const getDefaultState = () => {
    return {
        search: null,
        selectedCategories: [],
        selectedCommunes: [],
        selectedWebFormStates: [],
        selectedTags: [],
        selectedTourismSectors: [],
    }
}

const cmajFilter = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setSearch(state, value) {
            state.search = value
        },
        setSelectedCategories(state, value) {
            state.selectedCategories = value
        },
        setSelectedCommunes(state, value) {
            state.selectedCommunes = value
        },
        setSelectedWebFormStates(state, value) {
            state.selectedWebFormStates = value
        },
        setSelectedTourismSectors(state, value) {
            state.selectedTourismSectors = value
        },
        setSelectedTags(state, value) {
            state.selectedTags = value
        },
        pushWebFormState(state, value) {
            if(!state.selectedWebFormStates.includes(value)) {
                state.selectedWebFormStates.push(value)
            }
        },
        removeUnavailableStates(state) {
            let availables = ['WITHOUT_EMAIL', 'WITHOUT_WEB_FORM']

            state.selectedWebFormStates = state.selectedWebFormStates.filter(_state => availables.includes(_state))
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        }
    }
}

export default cmajFilter